import React, { useState, useEffect } from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
// import Chart from 'chart.js/auto';
import axios from '../../../../api/axios';
import { DataGrid } from '@mui/x-data-grid';
import { Line } from 'react-chartjs-2';
import { PieChart } from '@mui/x-charts/PieChart';
import { useMediaQuery } from '@mui/material';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';
import { FormControl } from '@mui/material';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Dep from "./../../../../Images/svgtopng/Dep.png";
import mem from "./../../../../Images/svgtopng/mem.png";
import upret from "./../../../../Images/svgtopng/upret.png"
import { CSVLink } from 'react-csv';
import DataList from './DataList';
import SmallCard from './Card';
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const URL = "./dealership/getDataCount";


const Dashboard = () => {
    // Initialize dataList as an empty array to avoid map errors
    const [dataList, setDataList] = useState([]);
    const [cardList, setCardList] = useState([]);
    const [Amount, setAmount] = useState([]);


    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const isMediumScreen = useMediaQuery('(max-width:900px)');
    const textfieldStyles = {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'lightgray', // Default border color
            },
            '&:hover fieldset': {
                borderColor: 'lightgray', // Remove hover border color
            },
            '&.Mui-focused fieldset': {
                borderColor: 'lightgray', // Remove focus border color
            },
        },
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'memberID', headerName: 'Member ID', width: 150 },
        { field: 'Name', headerName: 'Name', width: 200 },
        { field: 'fathersName', headerName: "Father's Name", width: 200 },
        { field: 'adharNo', headerName: 'Aadhar No.', width: 150 },
        { field: 'dob', headerName: 'Date of Birth', width: 150 },
        { field: 'joinDate', headerName: 'Join Date', width: 150 },
        { field: 'mobileNo', headerName: 'Mobile No.', width: 150 },
        { field: 'department', headerName: 'Department', width: 150 },
        // { field: 'status', headerName: 'Status', width: 150 },
        // {
        //     field: 'actions',
        //     headerName: 'Actions',
        //     width: 200,
        //     renderCell: (params) => (
        //         <div style={{ display: 'flex', gap: '10px' }}>
        //             <EditData selectedRow={params.row} />
        //             <DeleteData selectedRow={params.row} />
        //         </div>
        //     )
        // }
    ];

    const state = {

        series: [{
            name: "Session Duration",
            data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
            borderColor: "red"
        },
        {
            name: "Page Views",
            data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35]
        },
        {
            name: 'Total Visits',
            data: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47]
        }
        ],
        options: {
            chart: {
                height: 350,
                type: 'line',
                zoom: {
                    enabled: false
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                width: [5, 7, 5],
                curve: 'straight',
                dashArray: [0, 8, 5]
            },
            title: {
                text: 'Sales Info',
                align: 'left'
            },
            legend: {
                tooltipHoverFormatter: function (val, opts) {
                    return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
                }
            },
            markers: {
                size: 0,
                hover: {
                    sizeOffset: 6
                }
            },
            xaxis: {
                categories: ['01 Jan', '02 Jan', '03 Jan', '04 Jan', '05 Jan', '06 Jan', '07 Jan', '08 Jan', '09 Jan',
                    '10 Jan', '11 Jan', '12 Jan'
                ],
            },
            tooltip: {
                y: [
                    {
                        title: {
                            formatter: function (val) {
                                return val + " (mins)"
                            }
                        }
                    },
                    {
                        title: {
                            formatter: function (val) {
                                return val + " per session"
                            }
                        }
                    },
                    {
                        title: {
                            formatter: function (val) {
                                return val;
                            }
                        }
                    }
                ]
            },
            grid: {
                borderColor: '#f1f1f1',
            }
        },


    };




    const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
    const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
    const xLabels = [
        'Page A',
        'Page B',
        'Page C',
        'Page D',
        'Page E',
        'Page F',
        'Page G',
    ];
    // Sample data for the chart
    const data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Sales',
                data: Amount,
                borderColor: '#3f51b5',
                backgroundColor: 'rgba(63, 81, 181, 0.5)',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Sales Over Time',
            },
        },
        scales: {
            y: {
                beginAtZero: true, // Start from 0 on the y-axis
                ticks: {
                    stepSize: 100000, // Set interval of 100000
                    callback: function (value) {
                        return value.toLocaleString(); // Format the tick labels with commas (e.g., 100,000)
                    },
                },
                suggestedMax: 300000, // Set a suggested maximum value to fit your data
            },
        },
    };
    const dataN = {
        labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        datasets: [
            {
                label: 'Data',
                data: [2, 3, 5.5, 8.5, 1.5, 5, 1, 4, 3, 8],
                borderColor: '#FF5733', // Line color
                borderWidth: 2,
                pointBackgroundColor: '#FF5733', // Color of points
                pointBorderWidth: 2,
                showLine: true,
                pointRadius: (ctx) => (ctx.dataIndex % 2 === 0 ? 5 : 0), // Show marks on even indices
            },
        ],
    };

    const optionsN = {
        plugins: {
            legend: {
                display: false,
            },
        },
        elements: {
            line: {
                borderWidth: 2,
                tension: 0.4,
            },
            point: {
                radius: 5,
            },
        },
    };

    const data3 = [
        { label: 'Group A', value: 400 },
        { label: 'Group B', value: 300 },
        { label: 'Group C', value: 300 },
        { label: 'Group D', value: 200 },
    ];

    const data4 = [
        { label: 'A1', value: 100 },
        { label: 'A2', value: 300 },
        { label: 'B1', value: 100 },
        { label: 'B2', value: 80 },
        { label: 'B3', value: 40 },
        // { label: 'B4', value: 30 },
        // { label: 'B5', value: 50 },
        // { label: 'C1', value: 100 },
        // { label: 'C2', value: 200 },
        // { label: 'D1', value: 150 },
        // { label: 'D2', value: 50 },
    ];

    const data5 = [
        { value: 5, label: 'A' },
        { value: 10, label: 'B' },
        { value: 15, label: 'C' },
        { value: 20, label: 'D' },
    ];

    const size = {
        width: 400,
        height: 200,
    };

    const StyledText = styled('text')(({ theme }) => ({
        fill: theme.palette.text.primary,
        textAnchor: 'middle',
        dominantBaseline: 'central',
        fontSize: 20,
    }));




    useEffect(() => {
        loadData();
        loadDashboardCount();
    }, []);

    const loadData = async () => {
        try {
            const response = await axios.post("./employeeInformation/getRetirementData");

            if (response.data.status === 401) {
                setDataList([]); // Keep as empty array in case of unauthorized response
            } else {
                // const responseData = response.data.data;
                setDataList(response.data.message);
                console.log("dataList", response.data.message);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            setDataList([]); // Use empty array if request fails
        }
    };

    const loadDashboardCount = async () => {
        try {
            const response = await axios.post('./employeeInformation/getDashboardCount');

            if (response.data.status === 401) {
                setCardList([]); // Keep as empty array in case of unauthorized response
            } else {
                // const Amount = new Array();
                // const responseData = response.data.data;
                // for (let i = 0; i < responseData.length; i++) {
                //     Amount.push(responseData[i].total_sale_price);
                // }
                // setAmount(Amount);
                setCardList(response.data.message);
                console.log("data", response.data.message);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            setDataList([]); // Use empty array if request fails
        }
    };

    const convertImageToBase64 = async () => {
        // Make sure the image path is relative to the public folder
        const response = await fetch(`${process.env.PUBLIC_URL}/mrpl.png`);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(blob);
        });
    };

    const generatePdf = async (data) => {

        // Render the PDFPrint component as static HTML
        const LOGO = await convertImageToBase64();


        // Create the PDF document definition using the converted content
        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [20, 20, 20, 20],
            content: [
                {
                    table: {
                        widths: ['100%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: 'MRPL-ONGC KARMACHARI SANGHA (R)', border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 18
                                },
                            ],

                        ]
                    }
                },
                // First Table
                {
                    table: {
                        widths: ['25%', '75%'], // Set the width for each column
                        body: [
                            [
                                {
                                    image: LOGO, // Use the 'image' key for the logo
                                    rowSpan: 4,
                                    fit: [75, 75], // Adjust size as needed
                                    border: [false, false, false, false]
                                },
                                {
                                    text: `Affiliated to: MRPL Employee's Union (R.) and Petroleum & Gas Workers Federation of India.`,
                                    border: [false, false, false, false], fontSize: 7
                                }
                            ],
                            ['', { text: `REGD. No. TUA 495/2007`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `Near Cargo Gate, Opp. Oval Outlet, Bajpe Road Katipalla, Mangalore - 575030.`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `PH: 94807 66036      Email:mrplkarmacharisangha495@yahoo.com && moks.mrpl@gmail.com`, border: [false, false, false, false], bold: true, fontSize: 7 }],
                        ]
                    }
                },
                {
                    table: {
                        widths: ['100%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: `RETIREMENT LIST`, border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 15
                                },
                            ],

                        ]
                    }
                },
                {
                    table: {
                        widths: ['20%', '20%', '20%', '20%', '20%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: "Retirement Date",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Members ID",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Members Name",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Fathers/Husband Name",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Mobile NO",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                }
                            ],
                            ...dataList.map((item, index) =>
                                [
                                    {
                                        text: item.retirementDate,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.memberID,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.Name,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.fathersName,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.mobileNo,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    }
                                ]
                            )
                        ]
                    }
                }
            ]
        };

        // Generate the PDF and open it in a new tab
        pdfMake.createPdf(docDefinition).open();
    };

    const myColorArray = [
        "#3fb1e3",   // Light Blue
        "#626c91",   // Gray
        "#6be6c1",   // Light Blue
        "#626c91",   // Gray (duplicated)
    ];

    const myOtherColorArray = [
        "rgb(78, 202, 194)",   // Gray (fixed typo)
        "rgb(78, 202, 194)",   // Light Blue
        "red",   // Light Blue
        "rgb(239, 181, 64)",   // Gray
        "rgb(34, 197, 94)",   // Light Blue
    ];

    const StyledTextNEW = styled('text')(({ theme }) => ({
        fill: theme.palette.text.primary,
        textAnchor: 'middle',
        dominantBaseline: 'central',
        fontSize: 20,
    }));

    function PieCenterLabel({ children }) {
        const { width, height, left, top } = useDrawingArea();
        return (
            <StyledTextNEW x={left + width / 2} y={top + height / 2}>
                {children}
            </StyledTextNEW>
        );
    }
    const csvdata = [
        { month: 'January', value: 123 },
        { month: 'February', value: 234 },
        { month: 'March', value: 345 },
        { month: 'April', value: 456 },
        { month: 'May', value: 567 },
        { month: 'June', value: 678 },
        { month: 'July', value: 789 },
        { month: 'August', value: 890 },
        { month: 'September', value: 901 },
        { month: 'October', value: 1023 },
        { month: 'November', value: 1134 },
        { month: 'December', value: 1245 },
    ];

    const getDummyData = () => {
        console.log(cardList);
    }



    return (
        <Box p={2} style={{ marginTop: "50px" }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <SmallCard tablename={"Departments"} count={cardList.length > 0 ? cardList[1].row_count : "0"} index={'0'} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <SmallCard tablename={"Members"} count={cardList.length > 0 ? cardList[0].row_count : "0"} index={'1'} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <SmallCard tablename={"Upcoming Retirements"} count={cardList.length > 0 ? cardList[3].row_count : "0"} index={'2'} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <SmallCard tablename={"Payments"} count={cardList.length > 0 ? cardList[2].row_count : "0"} index={'3'} />
                </Grid>
            </Grid>

            {/* Chart */}
            <Grid container spacing={2} style={{ marginTop: "50px" }}>
                <Grid item xs={12} sm={12} md={12}>
                    <Paper elevation={3} style={{ padding: '0px', height: '350px', display: 'flex', flexDirection: 'column' }}>
                        {/* Title Section */}
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                padding: '20px',
                                borderBottom: '0.5px solid rgba(0, 0, 0, 0.5)',
                                justifyContent: 'space-between', // Space between the items
                                alignItems: 'center'  // Vertically center the items
                            }}
                        >
                            {/* Left - Typography */}
                            <Typography variant="h6" gutterBottom sx={{
                                flexGrow: 1, fontWeight: 'bold',  // Makes the text bold (thick)
                                color: 'grey',
                            }}>
                                Upcoming Retired
                            </Typography>

                            {/* Right - Button */}

                            <Button
                                variant="outlined"
                                size="small"
                                onClick={generatePdf}
                                sx={{
                                    whiteSpace: 'normal',
                                    textAlign: 'right',
                                    borderRadius: '8px', // Customize the border radius here
                                    borderColor: 'grey', // Set the border color to grey
                                    color: 'grey', // Set the text color to grey
                                    '&:hover': {
                                        borderColor: 'darkgrey', // Optional: Change border color on hover
                                        color: 'darkgrey', // Optional: Change text color on hover
                                    },
                                    // display:"none"
                                }}
                            >
                                {/* CSVLink wrapped inside the button with removed hyperlink styles */}

                                Export

                            </Button>
                        </Stack>

                        {/* Pie Chart Section */}
                        <div style={{ width: '100%', height: '70%' }}>
                            <DataGrid
                                rows={dataList}
                                columns={columns}
                                pageSize={5}
                                rowsPerPageOptions={[5]}
                                experimentalFeatures={{ newEditingApi: true }}
                                // components={{
                                //     Toolbar: () => (
                                //         <Box
                                //             sx={{
                                //                 padding: 2,
                                //                 display: 'flex',
                                //                 justifyContent: 'flex-start',
                                //                 borderBottom: '2px solid #3f51b5',
                                //             }}
                                //         >
                                //             <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'darknavy' }}>
                                //                Retired  Members
                                //             </Typography>
                                //         </Box>
                                //     ),
                                // }}
                                sx={{
                                    '& .MuiDataGrid-columnHeaderTitle': {
                                        color: 'darknavy',
                                        fontWeight: 'bold',
                                    },
                                }}
                            />
                        </div>

                        {/* Typography Section with Left, Center, Right alignment */}

                    </Paper>
                </Grid>


            </Grid>

            <Box mt={4} mb={4} md={6} xs={12}></Box>

            {/* Table */}
            <Box></Box>
        </Box>
    );
};

export default Dashboard;
